export const AdvertisingCookies = {
  cookiesTable: [
    {
      vendor: 'Facebook',
      vendorURL: 'https://www.facebook.com/privacy/policy/',
      cookies: '_fbp, _fbc, fr'
    },
    {
      vendor: 'Google',
      vendorURL: 'https://business.safety.google/privacy/',
      cookies: '_gcl_au, _gcl_aw, APISID, SSID, HSID, SID, SAPISID, NID, test_cookie, IDE, gcl_dc'
    },
    {
      vendor: 'NextRoll',
      vendorURL: 'https://www.nextroll.com/privacy',
      cookies: '__ar_v4, __adroll_fpc, __adroll, __adroll_shared'
    },
    {
      vendor: 'Microsoft',
      vendorURL: 'https://www.microsoft.com/en-us/privacy/privacystatement',
      cookies: '_uetvid, _uetsid, MR, MUID, uuid2, anj, _clck, _uetmsclkid'
    },
    {
      vendor: ' Index Exchange',
      vendorURL: 'https://www.indexexchange.com/privacy/exchange-platform-privacy-policy/',
      cookies: 'CMID, CMPS, CMPRO, DSID'
    },
    {
      vendor: 'Bidswitch',
      vendorURL: 'https://www.bidswitch.com/privacy-policy/',
      cookies: 'tuuid, c, tuuid_lu'
    },
    {
      vendor: 'Pubmatic',
      vendorURL: 'https://pubmatic.com/legal/privacy/',
      cookies: 'KRTBCOOKIE_10'
    },
    {
      vendor: 'Linkedin',
      vendorURL: 'https://www.linkedin.com/legal/privacy-policy',
      cookies: 'UserMatchHistory, bcookie, bscookie, li_sugr, li_adsId'
    },
    {
      vendor: 'Intercom',
      vendorURL: 'https://www.intercom.com/legal/privacy',
      cookies: 'intercom-session-<id>'
    },
    {
      vendor: 'Salesloft',
      vendorURL: 'https://www.salesloft.com/legal/platform-privacy-notice',
      cookies: 'driftt_aid'
    },
    {
      vendor: 'Beamer',
      vendorURL: 'https://www.getbeamer.com/privacy-policy',
      cookies:
        '_BEAMER_FILTER_BY_URL_{}, _BEAMER_USER_ID_{}, _BEAMER_LAST_POST_SHOWN_{}, _BEAMER_DATE_{}'
    },
    {
      vendor: 'Dealfront / Leadfeeder',
      vendorURL: 'https://www.dealfront.com/privacy-notice',
      cookies: '_lfa'
    },
    {
      vendor: 'Reddit',
      vendorURL: 'https://www.reddit.com/policies/privacy-policy?rdt=44541',
      cookies: '_rdt_uuid, _rdt_cid'
    }
  ]
};
